module.exports = __webpack_public_path__ + "static/media/16_pol_0_90.74.5657827a.png";